// web/PwaInstallPage.jsx
export default function pwaInstallPage() {
  return (
    <div style={{ padding: '2rem', fontSize: '1.2rem' }}>
      <h2>PWAアプリ未インストールです</h2>
      <p>
        スマホでこのページをホーム画面に追加することで、より快適にご利用いただけます。
        <br />
        インストール手順を以下にご案内します。
      </p>
      <ul>
        <li>Safari: 共有ボタン → ホーム画面に追加</li>
        <li>Chrome: メニュー → アプリをインストール</li>
      </ul>
    </div>
  );
}
